import { DEFAULT_TAGS_LAYOUT } from '../components/TagCollection/TagCollection.config';
import { Tag } from '../types';
import { buildTagIconUrl } from './buildTagIconUrl';

/**
 * Loads icons for tags in parallel, and place it on the tag object, when image is present and loaded
 */
export const loadIcons = async (tags: Tag[]) =>
    Promise.allSettled(
        tags.map(
            (tag) =>
                new Promise<void>((resolve) => {
                    const iconUrl = buildTagIconUrl(tag);
                    if (!iconUrl) {
                        return resolve();
                    }

                    const img = new Image();
                    img.width = DEFAULT_TAGS_LAYOUT.iconSize;
                    img.height = DEFAULT_TAGS_LAYOUT.iconSize;
                    img.alt = tag.label;
                    img.onload = () => {
                        tag.icon = img;

                        resolve();
                    };
                    img.onerror = () => {
                        resolve();
                    };
                    img.src = iconUrl;
                })
        )
    );
